import * as React from 'react';
import {DocumentTypes} from '../../types/types';
import {LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import {AttachmentsDeleteDispatchProps, AttachmentsDeleteStateProps} from '../../types/containers';

class AttachmentDeleteModalView extends React.Component<AttachmentsDeleteStateProps &
    AttachmentsDeleteDispatchProps, {}> {

    renderDetail = (versions: number, documentType: DocumentTypes, filesQueue: number, filesUploaded: number) => {
        const commonMessage: string = 'Estas a punto de eliminar permanentemente el último archivo adjunto. ' +
            'Esta opción no se puede deshacer.';
        let message = filesUploaded === 1 && versions === 0 ? <div>
            {commonMessage} <br/>Si eliminas todos los archivos adjuntos el documento
            <b> {documentType.label} </b> quedará vacío.
        </div> : filesUploaded === 1 && versions !== 0 ? <div>
            {commonMessage} <br/> Si eliminas todos los archivos adjuntos el documento <b> {documentType.label} </b>
            regresarás a la versión anterior guardada.
        </div> : '';

        if (filesQueue > 0 || filesUploaded > 1) {
            message = <div>
                Estas a punto de eliminar permanentemente el archivo adjunto. Esta opción no se puede deshacer.
            </div>;
        }

        return message;
    }

    renderButton = (onPressDeleteConfirm, onPressClose) => (
        <div>
            <a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
               onClick={onPressClose}>{LOAN_APPLICATION_MX.FILE_DELETE_CANCEL_BUTTON}</a>
            <a className="h-auto btn btn-link border-0 btn-form text-warning py-0 pr-0"
               onClick={onPressDeleteConfirm}>{LOAN_APPLICATION_MX.FILE_DELETE_CONFIRM_BUTTON}</a>
        </div>
    )

    render() {
        const {onPressClose, onPressDeleteConfirm, versions, documentType, filesQueue, filesUploaded} = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify pb-4">
                    {this.renderDetail(versions, documentType, filesQueue.length, filesUploaded)}
                </div>
                <div className="pt-3 pb-2 px-0 text-right border-top">
                    {this.renderButton(onPressDeleteConfirm, onPressClose)}
                </div>
            </div>
        );
    }
}

export default AttachmentDeleteModalView;